import { render, staticRenderFns } from "./TypeCardMessage.vue?vue&type=template&id=6f371f9c&scoped=true"
import script from "./TypeCardMessage.vue?vue&type=script&lang=js"
export * from "./TypeCardMessage.vue?vue&type=script&lang=js"
import style0 from "./TypeCardMessage.vue?vue&type=style&index=0&id=6f371f9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f371f9c",
  null
  
)

export default component.exports